// Imperative navigation for code outside React components (redux thunks,
// action callbacks, class components). It replaces the `history` object that
// react-router v4 used: the data router created in routes/router.jsx is
// registered here and all calls are delegated to router.navigate().

let activeRouter = null;

export const setRouter = (router) => {
  activeRouter = router;
};

export const getRouter = () => activeRouter;

const navigate = (to, options) => {
  if (!activeRouter) {
    throw new Error('Router is not initialized');
  }
  return activeRouter.navigate(to, options);
};

const history = {
  push: (to, state) => navigate(to, state === undefined ? undefined : { state }),
  replace: (to, state) => navigate(to, { replace: true, ...(state === undefined ? {} : { state }) }),
  go: delta => navigate(delta),
  goBack: () => navigate(-1),
  goForward: () => navigate(1),
  get location() {
    return activeRouter ? activeRouter.state.location : window.location;
  },
};

export default history;
